import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public isLoading = new BehaviorSubject(false);
  public loading = false;
  private requests=[]
  constructor() {
    
    this.isLoading.subscribe((val) => {
      this.loading = val;
    });
  }
  addRequest(request:HttpRequest<any>):void{
    this.requests.push(request)
  }
  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
   
    this.isLoading.next(this.requests.length > 0);
  }
}
